/* eslint-disable camelcase */
// #region Dependencias
import { onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from 'services/firebase'
import {
  checkAuthFinish,
  checkAuthStart,
  loadAuthFinish,
  loadAuthStart,
  login,
  logout
} from 'store/slices/authSlice'
import { responseMessageHandler } from 'utils/responseMessageHandler'
// #endregion

/**
 * Thunk que verifica el estado de autenticación actual para obtener información
 * del usuario autenticado y establecer las propiedades del usuario autenticado.
 *
 * @return {Function} Función que envía las acciones asíncronas al store de Redux.
 */
export const checkAuthRequest = () => async (dispatch) => {
  dispatch(checkAuthStart())
  onAuthStateChanged(auth, (usuario) => {
    if (!usuario) dispatch(logout())
    if (usuario) {
      const { uid, email, is_anon } = usuario
      if (!is_anon) dispatch(login({ uid, email }))
    }
    dispatch(checkAuthFinish())
  })
}

/**
 * Thunk que realiza una solicitud de inicio de sesión para el usuario proporcionado.
 *
 * @param {Object} usuario - Objeto que contiene el correo electrónico y la contraseña del usuario.
 * @param {string} usuario.correo - Correo electrónico del usuario.
 * @param {string} usuario.clave - Contraseña del usuario.
 * @return {Function} Función que envía las acciones asíncronas al store de Redux.
 */
export const loginRequest = (usuario) => async (dispatch) => {
  const { correo, clave } = usuario
  dispatch(loadAuthStart())
  signInWithEmailAndPassword(auth, correo, clave)
    .then(() => dispatch(checkAuthRequest()))
    .catch((err) => responseMessageHandler(err, dispatch))
    .finally(() => dispatch(loadAuthFinish()))
}
